export default __webpack_public_path__ + "static/media/EAST2480.34I-34282_-18536_0.3a97c56c.jpg";